import { render, staticRenderFns } from "./WebsiteHeaderBoxed.vue?vue&type=template&id=fc186580"
import script from "./WebsiteHeaderBoxed.vue?vue&type=script&lang=ts"
export * from "./WebsiteHeaderBoxed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports